<div class="form-floating mb-2 position-relative">
    <input [type]="type" class="form-control" [placeholder]="placeholder" [(ngModel)]="initialValue" [name]="name"
        [disabled]="disabled" [id]="name" (ngModelChange)="emitOutput()"
        [ngClass]="{'is-valid': isValid, 'is-invalid': isValid === false}">
    <label [for]="name">{{placeholder}}</label>
</div>